
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteJ as ObiOwnShipRemoteJElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-j.js';
 
 
 

 
 export const ObiOwnShipRemoteJ = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-j',
   elementClass: ObiOwnShipRemoteJElement,
   events: {
     
   }
  });
 
 